import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useCallback, useContext, useEffect, useRef } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { tuple } from '../_utils/type';
export var NotificationTypes = tuple('success', 'warning', 'error', 'info', 'primary');
var Notice = function Notice(props) {
  var _context, _classNames;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var noticeProps = getCompProps('Notice', userDefaultProps, props);
  var customPrefixcls = noticeProps.prefixCls,
    className = noticeProps.className,
    content = noticeProps.content,
    closable = noticeProps.closable,
    duration = noticeProps.duration,
    style = noticeProps.style,
    type = noticeProps.type,
    onClose = noticeProps.onClose,
    suffixCls = noticeProps.suffixCls,
    key = noticeProps.key;
  var noticePrefixCls = getPrefixCls(prefixCls, suffixCls, customPrefixcls);
  var timer = null;
  var isTransition = false;
  var noticeRef = useRef();
  var noticeClasses = classNames(noticePrefixCls, className, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(noticePrefixCls, "-")).call(_context, type), type), _defineProperty(_classNames, "".concat(noticePrefixCls, "-closable"), closable), _classNames));
  var animationEvent = function animationEvent() {
    var _a, _b;
    (_a = noticeRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove("".concat(noticePrefixCls, "-leave"));
    (_b = noticeRef.current) === null || _b === void 0 ? void 0 : _b.classList.add("".concat(noticePrefixCls, "-leave-after"));
  };
  var transitionEvent = function transitionEvent() {
    if (!isTransition) {
      onClose && onClose(key);
    }
    isTransition = true;
  };
  var clearEventListener = function clearEventListener() {
    var _a, _b;
    (_a = noticeRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('animationend', animationEvent);
    (_b = noticeRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('transitionend', transitionEvent);
  };
  var handleClose = function handleClose() {
    var _a, _b, _c;
    isTransition = false;
    (_a = noticeRef.current) === null || _a === void 0 ? void 0 : _a.classList.add("".concat(noticePrefixCls, "-leave"));
    (_b = noticeRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('animationend', animationEvent);
    (_c = noticeRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener('transitionend', transitionEvent);
  };
  var startCloseTimer = useCallback(function () {
    if (!duration) return;
    timer = setTimeout(function () {
      handleClose();
    }, duration);
  }, [duration]);
  var clearCloseTimer = useCallback(function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }, [duration]);
  useEffect(function () {
    startCloseTimer();
    return function () {
      clearCloseTimer();
      clearEventListener();
    };
  }, [duration]);
  return /*#__PURE__*/React.createElement("div", {
    className: noticeClasses,
    style: style,
    onMouseEnter: clearCloseTimer,
    onMouseLeave: startCloseTimer,
    ref: noticeRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(noticePrefixCls, "-content")
  }, content));
};
Notice.displayName = 'Notice';
export default Notice;